import React, { FC } from 'react';

import EntityShowPage from '@buyside/components/presentation/CompanyShowPage/entityShowPage';
import ErrorBoundary from '@buyside/components/presentation/ErrorBoundary/errorBoundary';

const EntityShowPageRoot: FC<{ entityId: string; isCrypto: string }> = ({ entityId, isCrypto }) => {
  if (!entityId) return;

  return (
    <ErrorBoundary pageName="the company page">
      <EntityShowPage id={entityId} isPublic={false} isCrypto={isCrypto === 'true'} />
    </ErrorBoundary>
  );
};

export default EntityShowPageRoot;
